import { connect } from 'react-redux';

import DownloadPage from '../../components/DownloadPage/DownloadPage';
import { archivator, checkFileSize } from '../../actions/CurrentAccount';


const mapStateToProps = (state) => ({
    zipOriginalName: state.currentAccount.zipOriginalName,
    zipSize: state.currentAccount.zipSize,
    isZipReady: state.currentAccount.isZipReady,

    isFetching: state.currentAccount.isFetching, 
})

const mapDispatchToProps = (dispatch) => ({
    archivator: (basketData) => {
        dispatch(archivator(basketData))
    },
    checkFileSize: (data) => {
        dispatch(checkFileSize(data))
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(DownloadPage)
